import { render, staticRenderFns } from "./RelationshipsRiskAssesments.vue?vue&type=template&id=f7720ebe&"
import script from "./RelationshipsRiskAssesments.vue?vue&type=script&lang=js&"
export * from "./RelationshipsRiskAssesments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports